import request from 'local_modules/request'
import { reducers } from 'redux/core'
import { constants } from 'helpers'
import { getImageLink } from 'voting/helpers'


const setFetching = (isFetching) => {
  return reducers.voting.homePage.setFetching(isFetching)
}

const fetch = () => {
  return request.get(constants.voting.getPoll)
    .then(({ data }) => data)
    .then((poll) => reducers.voting.homePage.setPoll(poll))
    .catch((error) => {
      console.log({ error })
    })
}

// const fetchProjects = () => {
//   return request.get(constants.voting.getShortNews)
//     .then(({ data }) => data)
//     .then((projects) => (
//       projects.map((project) => ({
//         ...project,
//         image: getImageLink({ imageId: project.imageId })
//       }))
//     ))
//     .then((projects) => reducers.voting.homePage.setProjects(projects))
//     .catch((error) => {
//       console.log({ error })
//     })
// }
//
// const fetchVotes = ({ votingId }) => {
//   return request.get(constants.voting.votes + `?votingId=${votingId}`)
//     .then(({ data }) => data)
//     .then((votes) => reducers.voting.homePage.setVotes({ votingId, votes }))
//     .catch((error) => {
//       console.log({ error })
//     })
// }
//
// const fetchMyVotes = ({ votingId }) => {
//   return request.get(constants.voting.myVotes + `?votingId=${votingId}`)
//     .then(({ data }) => data)
//     .then((projects) => reducers.voting.homePage.setMyVotes(projects))
//     .catch((error) => {
//       console.log(error)
//       reducers.voting.homePage.setMyVotes([])
//     })
// }
//
// const sendProjectVote = ({ votingId = 1, entityId }) => {
//   return request.get(constants.voting.setVote + `?votingId=${votingId}&entityId=${entityId}`)
//     .then(({ data }) => console.log({ data }))
//     .catch((error) => {
//       console.log({ error })
//     })
// }
//
// const fetchProject = (id) => {
//   return request.get(constants.voting.getNews + `?id=${id}`)
//     .then(({ data }) => data)
//     .then((project) => {
//       const { imageId, author, date, ...rest } = project
//
//       reducers.voting.homePage.setProject({
//         pathname: id,
//         post: {
//           ...rest,
//           date: date ? date.replace(/\s.+/, '') : '',
//           author: author ? `${author.firstName} ${author.lastName}` : author,
//           image: getImageLink({ imageId }),
//         },
//       })
//     })
//     .catch((error) => {
//       console.log({ error })
//     })
// }


export default {
  setFetching,
  fetch,

  // fetchProject,
  // fetchProjects,
  // fetchVotes,
  // fetchMyVotes,
  // sendProjectVote,
}
